<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title"><template v-if="auxiliary">{{auxiliary.name}} -</template> 核算项目余额</span>
			<span class="dark4-color">提示：按 Ctrl + F 键并输入信息可以快速查找。</span>
		</div>
		<Row type="flex" :space-x="10" class="margin-right-left margin-top">
			<Cell>
				<account-date-choose v-model="accountDate"/>
			</Cell>
			<Cell class="label">辅助类别：</Cell>
			<Cell>
				<Select type="object" v-model="auxiliary" :deletable="false" style="min-width: 100px" :datas="auxiliaryType" keyName="id" titleName="name"/>
			</Cell>
			<Cell>
				<Button :disabled="!auxiliary" :loading="loading" color="primary" @click="doSearch">查询</Button>
			</Cell>
      <Cell></Cell><Cell></Cell><Cell></Cell>
      <Cell class="label">模糊查询：</Cell>
      <cell>
        <input type="text" v-model="auxiliaryCode" placeholder="请输入项目编码或名称" style="min-width: 100px"/>
		  </cell>
      <Cell>
        <Button :disabled="!auxiliary" :loading="loading" color="primary" @click="doSearch1">查询</Button>
      </Cell>
      <Cell>
        <Button :disabled="!auxiliary" :loading="loading" color="primary" @click="doSearch2">重置</Button>
      </Cell>
			<Cell :flex="1">
				<!--<div class="float-right">
					<Checkbox v-model="showNumPrice">显示数量金额</Checkbox>
				</div>-->
			</Cell>
		</Row>
		<div class="h-panel-body">
			<table class="balance" v-if="auxiliary">
				<thead class="header">
				<tr>
					<td rowspan="2">{{auxiliary.name}}编码</td>
					<td rowspan="2">{{auxiliary.name}}名称</td>
					<td colspan="2">期初余额</td>
					<td colspan="2">本期发生额</td>
					<td colspan="2">期末余额</td>
				</tr>
				<tr>
					<td>借方</td>
					<td>贷方</td>
					<td>借方</td>
					<td>贷方</td>
					<td>借方</td>
					<td>贷方</td>
				</tr>
				</thead>
				<tbody>
				<tr v-for="item in dataList" :key="item.subjecId">
          <!-- 显示辅助核算项目编码 -->
					<td :style="{'padding-left':(item.level)*10+'px'}">{{item.code}}</td>
					<!-- 显示辅助核算项目名称 -->
					<td :style="{'padding-left':(item.level)*10+'px'}"><span class="text-hover">{{item.name}}</span></td>
          <!-- 显示期初借方余额 -->
					<td>{{item.beginningDebitBalance|numFormat}}</td>
          <!-- 显示期初贷方余额 -->
					<td>{{item.beginningCreditBalance|numFormat}}</td>
          <!-- 显示本期借方发生额 -->
					<td>{{item.currentDebitAmount|numFormat}}</td>
          <!-- 显示本期贷方发生额 -->
					<td>{{item.currentCreditAmount|numFormat}}</td>
          <!-- 显示期末借方余额 -->
					<td :class="{tip:item.endingDebitBalance<0}">{{item.endingDebitBalance|numFormat}}</td>
          <!-- 显示期末贷方余额 -->
					<td :class="{tip:item.endingCreditBalance<0}">{{item.endingCreditBalance|numFormat}}</td>
				</tr>
				<tr v-if="!dataList.length">
					<td colspan="8" class="text-center padding">暂无数据</td>
				</tr>
				</tbody>
			</table>
		</div>
	</app-content>
</template>

<script>
/**
 * 辅助核算余额
 */
	export default {
		name: "AuxiliaryAccountingBalance",
		data() {
			return {
				dataList: [],// 辅助核算余额数据列表
				showNumPrice: false,// 是否显示数量金额
				loading: false,// 加载状态
				accountDate: null,// 会计日期
				auxiliary: null,// 辅助核算项
				auxiliaryItem: {},// 辅助核算项详情
				auxiliaryType: [],// 辅助核算类型列表
				auxiliaryList: [],// 辅助核算项目列表
        // 辅助核算项目编码
        auxiliaryCode: null// 辅助核算项目编码
			}
		},
		methods: {
      /**
       * 加载辅助核算类型数据
       *
       * @description 从API获取会计科目分类列表数据，设置辅助核算类型选项，并默认选中第一个选项
       * @returns {void}
       */
			loadAuxiliaryType() {
        // 获取会计科目分类列表数据
				this.$api.setting.accountingCategory.list().then(({data}) => {
					this.auxiliaryType = data;
          // 如果存在数据，则默认选中第一个选项
					if (data.length) {
						this.auxiliary = data[0];
					}
				});
			},
      /**
       * 加载辅助余额列表数据
       *
       * 该函数根据辅助核算项ID和会计日期查询对应的辅助余额数据，
       * 查询过程中会显示加载状态，查询完成后更新数据列表并关闭加载状态
       */
			loadList() {
        // 检查辅助核算项是否存在，避免无效请求
				if (this.auxiliary) {
          // 设置加载状态为true，显示加载动画
					this.loading = true;
          // 调用API接口加载辅助余额数据
					this.$api.accountbook.loadAuxiliaryBalance({
						accountDate: this.accountDate,
						auxiliaryId: this.auxiliary.id
					}).then(({data}) => {
            // 将返回的数据赋值给数据列表
						this.dataList = data;
					}).finally(() => {
            // 无论请求成功或失败，最终都要关闭加载状态
						this.loading = false;
					});
				}

			},
			doSearch() {
				this.loadList();
			},
      doSearch2(){
        this.auxiliaryCode = null;
        this.loadList();
      },
      doSearch1() {
        // this.loadList();
        // 过滤数据列表，只保留编码包含辅助核算项目编码的项
        // this.dataList = this.dataList.filter(item => item.code.includes(this.auxiliaryCode));
        if (this.auxiliaryCode) {
          // this.loadList();
          // 调用模糊查询方法过滤数据
          this.filterDataByKeyword(this.auxiliaryCode);
        }
      },
      /**
       * 根据关键字模糊查询数据列表
       * 支持同时匹配编码（code）和名称（name）字段
       * @param {String} keyword - 查询关键字，支持模糊匹配
       */
      filterDataByKeyword(keyword) {
        // 将查询关键字转换为小写并去除首尾空格
        const searchKey = String(keyword).toLowerCase().trim();

        // 对数据列表进行过滤
        const filteredData = this.dataList.filter(item => {
          // 获取编码和名称字段值，转换为字符串并转为小写
          const code = String(item.code || '').toLowerCase();
          const name = String(item.name || '').toLowerCase();

          // 只要编码或名称包含查询关键字就保留该条记录
          return code.includes(searchKey) || name.includes(searchKey);
        });
        // 计算各项金额的合计值
        const totalItem = {
          isTotal: true, // 标记为合计行
          code: '',
          name: '合计',
          beginningDebitBalance: filteredData.reduce((sum, item) => sum + (item.beginningDebitBalance || 0), 0),
          beginningCreditBalance: filteredData.reduce((sum, item) => sum + (item.beginningCreditBalance || 0), 0),
          currentDebitAmount: filteredData.reduce((sum, item) => sum + (item.currentDebitAmount || 0), 0),
          currentCreditAmount: filteredData.reduce((sum, item) => sum + (item.currentCreditAmount || 0), 0),
          endingDebitBalance: filteredData.reduce((sum, item) => sum + (item.endingDebitBalance || 0), 0),
          endingCreditBalance: filteredData.reduce((sum, item) => sum + (item.endingCreditBalance || 0), 0)
        };

        // 将合计对象添加到过滤结果的末尾
        this.dataList = [...filteredData, totalItem];
      }
		},
		mounted() {
			this.loadAuxiliaryType();
		}
	}
</script>

<style scoped lang="less">
	.h-panel-bar {
		display: flex; /* 使用 Flexbox 布局 */
		justify-content: space-between; /* 让子元素两端对齐 */
    align-items: center;  /* 垂直居中对齐 */
	}
	.balance {
		width: 100%;
		border-collapse: collapse;

		td {
			padding: 0 8px;
			border: 1px solid #e2e2e2;
			font-size: 12px;
			height: 35px;

			&.tip {
				background-color: #FFEEEF;
			}
		}

		tbody tr:nth-child(even) {
			background-color: #f8fbf8;
		}

		tbody tr:hover {
			background-color: #F0F6FF;
		}

		.header {
			td {
				background-color: #F5F5F5;
				text-align: center;
				font-weight: bold;
			}
		}
	}
</style>